import React from 'react';
import { Dropdown } from 'semantic-ui-react';

export const MONTHNAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

class SearchableFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      selectedValue: ''
    };
  }

  // utils
  setFDs(fds, addAll, callback) {
    const values = [];
    if (addAll) {
      values.push({ value: null, text: 'All' });
    }

    fds.forEach(fd => {
      values.push({
        value: fd.id,
        text: fd.name
      });
    });

    this.setFilterItems(values, callback);
  }

  setYears(callback) {
    const year = new Date().getFullYear();
    const years = [];
    for (let i = -3; i < 3; i++) {
      years.push(year + i);
    }
    this.setFilterItems(years, callback);
  }

  setManyYears(callback) {
    const year = new Date().getFullYear();
    const years = [];
    for (let i = 2; i > -50; i--) {
      years.push(year + i);
    }
    this.setFilterItems(years, callback);
  }

  setMonths(callback) {
    this.setFilterItems(MONTHNAMES, callback);
  }

  setFilterItems(items, callback) {
    const filters = items.map(item =>
      typeof item === 'object'
        ? { key: item.value, value: item.value, text: item.text }
        : { key: item, value: item, text: item.toString() }
    );
    let selectedValue;

    if (this.props.defaultValue !== undefined && this.props.defaultValue !== null) {
      selectedValue = this.props.defaultValue;
    } else if (filters.length > 0) {
      selectedValue = filters[0].value;
    } else {
      selectedValue = null;
    }

    this.setState(
      {
        filters: filters,
        selectedValue: selectedValue
      },
      callback || function () { }
    );
  }

  handleChange = (e, { value }) => {
    const previous = this.state.selectedValue;
    this.setState({ selectedValue: value }, () => {
      if (this.props.handleFilterChange && previous !== value) {
        this.props.handleFilterChange(this, value);
      }
    });
  };

  handleAddition = (e, { value }) => {
    const previous = this.state.selectedValue;
    this.setState(
      prevState => ({
        filters: [
          { key: value, value, text: value.toString() },
          ...prevState.filters
        ],
        selectedValue: value
      }),
      () => {
        if (this.props.handleFilterChange && previous !== value) {
          this.props.handleFilterChange(this, value);
        }
      }
    );
  };

  render() {
    return (
      <Dropdown
        button
        className="icon"
        floating
        labeled
        search
        selection
        additionLabel="Filter by: "
        allowAdditions
        onAddItem={this.handleAddition}
        onChange={this.handleChange}
        value={this.state.selectedValue}
        options={this.state.filters}
        icon="filter"
        style={{ textAlign: 'left' }}
      />
    );
  }
}

export default SearchableFilter;
